  
  <main id="content" role="main" class="main bg-white">
    <!-- Content -->
    <div class="container py-20 py-sm-7">
      <div class="mx-auto"  *ngIf="platform=='web'">
        <div class="mb-5 p-2">
          <a class="d-flex justify-content-center mb-2 mt-5" routerLink="/">
            <img class="zi-2" src="../../../assets/images/DumyUser/touch.png" alt="Image Description" style="width: 8rem;">
          </a>
            <div class="js-validate needs-validation" novalidate>
              <div class="text-center">
                <div class="mb-5">
                  <h1 class="display-5">
                    {{'SIGN_UP' | translate}}
                  </h1>
                  <p>
                    {{'ALREADY_HAVE_ACCOUNT' | translate}} <a class="link" routerLink="/login">
                      {{'SIGN_IN' | translate}}
                    </a></p>
                </div>
              </div>
  
              <form [formGroup]="userForm" (ngSubmit)="onSubmit($event)" class="row">
                <div class="mb-1">
                  <label for="email" class="form-label">{{'EMAIL' | translate}}</label>
                  <input type="email" id="email" class="form-control form-control-lg" formControlName="email" placeholder="Jondoe@example.com">
                  <div class="error-message text-danger" *ngIf="userForm.get('email')?.invalid && userForm.get('email')?.touched">
                    <ng-container *ngIf="userForm.get('email')?.hasError('required')">{{'EMAIL_REQUIRED' | translate}}</ng-container>
                    <ng-container *ngIf="userForm.get('email')?.hasError('email')">{{'EMAIL_INVALID' | translate}}</ng-container>
                  </div>
                </div>
                <div class="mb-1">
                  <label for="password" class="form-label">{{'PASSWORD' | translate}}</label>
                  <input type="password" id="password" class="form-control form-control-lg" formControlName="password" >
                  <div class="error-message text-danger" *ngIf="userForm.get('password')?.invalid && userForm.get('password')?.touched">
                    {{'PASSWORD_REQUIRED' | translate}}
                  </div>
                </div>
                
                <div class="d-grid my-3" *ngIf="loading">
                  <button type="button" class="btn btn-primary btn-lg rounded-4 py-3">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  </button>
                </div>
                <div class="d-grid my-3" *ngIf="!loading">
                  <button type="submit" class="btn btn-primary btn-lg rounded-2 mb-3 py-3" [disabled]="userForm.invalid" style="background-color: rgb(80,34,116) !important;">
                    {{'sign_up' | translate}}
                  </button>
                </div>

              </form>
              <div class="position-relative d-flex align-items-center justify-content-center">
                <span class="divider"></span>
                <h6 class="position-absolute text-center divider-text bg-light-subtle mb-0">OR</h6>
             </div>
            <p-divider />
            <div class="action-btns d-grid" *ngIf="platform=='web'">
              <button  *ngIf="!loadingGoogle"  class="btn google-btn bg-white btn-lg shadow mb-1 d-block d-flex align-items-center text-decoration-none justify-content-center rounded-2" style="border: 1px solid #000;" (click)="RegisterWithGoogle($event)">
                  <img src="../../../assets/images/google.png" alt="google" class="me-3">
                  <span>
                    {{'CONNECT_WITH_GOOGLE' | translate}}
                  </span>
              </button>
              <button  *ngIf="loadingGoogle"  class="btn google-btn bg-white btn-lg shadow mb-1 d-block d-flex align-items-center text-decoration-none justify-content-center rounded-2" style="border: 1px solid #000;" >
                <img src="../../../assets/images/google.png" alt="google" class="me-3">
                <p-progress-spinner [style]="{ width: '30px', height: '30px' }"></p-progress-spinner>
            </button>
          </div>
          <div class="action-btns d-grid mt-2 pb-9" *ngIf="platform=='web'">
            <button *ngIf="!loadingapple"  class="btn google-btn  btn-lg btn-dark shadow  d-block d-flex align-items-center text-decoration-none justify-content-center rounded-2" style="border: 1px solid #000;" (click)="RegisterWithApple($event)">
              <img src="../../../assets/images/apple.png" alt="google" class="me-3 img-fluid" style="height: 35px;">
              <span>{{'CONNECT_WITH_APPLE' | translate}}</span>
            </button>
            <button *ngIf="loadingapple"   class="btn google-btn  btn-lg btn-dark shadow  d-block d-flex align-items-center text-decoration-none justify-content-center rounded-2" style="border: 1px solid #000;" >
              <img src="../../../assets/images/apple.png" alt="google" class="me-3 img-fluid" style="height: 35px;">
              <p-progress-spinner [style]="{ width: '30px', height: '30px' }"></p-progress-spinner>
            </button>
           </div>
            </div>
        </div>
      </div>
      <div class="mx-auto bg-white" *ngIf="platform!='web'">
        <div class="mb-5 p-2">
          <a class="d-flex justify-content-center mb-2 mt-5" routerLink="/">
            <img class="zi-2" src="../../../assets/images/DumyUser/touch.png" alt="Image Description" style="width: 15rem;">
          </a>
          <div class="card-body">
            <!-- Form -->
            <div class="js-validate needs-validation" novalidate>
              <div class="text-center pt-5">
                <div class="mb-5">
                  <h1 class="display-5">
                    {{'SIGN_UP' | translate}}
                  </h1>
                  <p>
                    {{'ALREADY_HAVE_ACCOUNT' | translate}} <a class="link" routerLink="/login">
                      {{'SIGN_IN' | translate}}
                    </a></p>
                </div>
              </div>
  
              <form [formGroup]="userForm" (ngSubmit)="onSubmit($event)" class="row">
                <div class="mb-1">

                  <label for="email" class="form-label">{{'EMAIL' | translate}}</label>
                  <input type="email" id="email" class="form-control form-control-lg" formControlName="email" placeholder="Jondoe@example.com">
                  <div class="error-message text-danger" *ngIf="userForm.get('email')?.invalid && userForm.get('email')?.touched">
                    <ng-container *ngIf="userForm.get('email')?.hasError('required')">{{'EMAIL_REQUIRED' | translate}}</ng-container>
                    <ng-container *ngIf="userForm.get('email')?.hasError('email')">{{'EMAIL_INVALID' | translate}}</ng-container>
                  </div>
                </div>
                <div class="mb-1">
                  <label for="password" class="form-label">{{'PASSWORD' | translate}}</label>
                  <input type="password" id="password" class="form-control form-control-lg" formControlName="password" >
                  <div class="error-message text-danger" *ngIf="userForm.get('password')?.invalid && userForm.get('password')?.touched">
                    {{'PASSWORD_REQUIRED' | translate}}
                  </div>
                </div>
              

                <div class="d-grid my-3" *ngIf="loading">
                  <button type="button" class="btn btn-primary btn-lg rounded-4 py-3">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  </button>
                </div>
                <div class="d-grid my-3" *ngIf="!loading">
                  <button type="submit" class="btn btn-primary btn-lg rounded-2 mb-3 py-3" [disabled]="userForm.invalid" style="background-color: rgb(80,34,116) !important;">Create Account</button>
                </div>

              </form>
              <div class="position-relative d-flex align-items-center justify-content-center">
                <span class="divider"></span>
                <h6 class="position-absolute text-center divider-text bg-light-subtle mb-0">OR</h6>
             </div>
            <p-divider />
  
            <div class="action-btns d-grid" *ngIf="platform!='web'">
              <button  *ngIf="!loadingGoogle"  class="btn google-btn bg-white btn-lg shadow mb-1 d-block d-flex align-items-center text-decoration-none justify-content-center rounded-2" style="border: 1px solid #000;" (click)="RegisterWithGoogleMobile($event)" >
                  <img src="../../../assets/images/google.png" alt="google" class="me-1">
                  <span>{{'CONNECT_WITH_GOOGLE' | translate}}</span>
              </button>
              <button  *ngIf="loadingGoogle"  class="btn google-btn bg-white btn-lg shadow mb-1 d-block d-flex align-items-center text-decoration-none justify-content-center rounded-2" style="border: 1px solid #000;" >
                <img src="../../../assets/images/google.png" alt="google" class="me-3">
                <p-progress-spinner [style]="{ width: '30px', height: '30px' }"></p-progress-spinner>
            </button>
          </div>
          <div class="action-btns d-grid mt-2 pb-9" *ngIf="platform!='web'">
            <button *ngIf="!loadingapple"  class="btn google-btn  btn-lg btn-dark shadow  d-block d-flex align-items-center text-decoration-none justify-content-center rounded-2" style="border: 1px solid #000;" (click)="RegisterWithAppleMobile($event)">
              <img src="../../../assets/images/apple.png" alt="google" class="me-3 img-fluid" style="height: 35px;">
              <span>{{'CONNECT_WITH_APPLE' | translate}}</span>
            </button>
            <button *ngIf="loadingapple"   class="btn google-btn  btn-lg btn-dark shadow  d-block d-flex align-items-center text-decoration-none justify-content-center rounded-2" style="border: 1px solid #000;" >
              <img src="../../../assets/images/apple.png" alt="google" class="me-3 img-fluid" style="height: 35px;">
              <p-progress-spinner [style]="{ width: '30px', height: '30px' }"></p-progress-spinner>
            </button>
           </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Content -->
  </main>



